module.exports = __webpack_public_path__ + "static/media/play_active.c47b2a32.svg";